<template>
  <div class="pt-3 px-3">
    <!-- A barra Aluno + Plano de Treino ja e exibida pela Navbar global (seleciona-aluno + selecion-plano-treino).
         O header proprio desta tela foi removido para nao duplicar. -->

    <div class="col-12">
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            class="nav-link active"
            id="dados-tab"
            data-bs-toggle="tab"
            data-bs-target="#dados"
            type="button"
            role="tab"
            aria-controls="dados"
            aria-selected="true"
          >
            {{ $t('studentData') }}
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="contratos-tab"
            data-bs-toggle="tab"
            data-bs-target="#contratos"
            type="button"
            role="tab"
            aria-controls="contratos"
            aria-selected="true"
          >
            {{ $t('contracts') }}
          </button>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <div
          class="tab-pane fade active show"
          id="dados"
          role="tabpanel"
          aria-labelledby="dados-tab"
        >
          <aluno-dados
            v-bind:quantidadeAulasMes="state.quantidadeAulasMes"
            v-on:update:quantidadeAulasMes="state.quantidadeAulasMes = $event"
          />
        </div>
        <div
          class="tab-pane fade show"
          id="contratos"
          role="tabpanel"
          aria-labelledby="contratos-tab"
        >
          <aluno-termo-adesao-lista />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted, computed, inject } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import moment from 'moment'
import AlunoDados from './AlunoDados.vue'
import AlunoTermoAdesaoLista from './alunoTermoAdesaoLista.vue'
import alunoRepository from '@/services/api/alunoRepository'
import planosTreinoRepository from '@/services/api/planosTreinoRepository'

export default {
  components: {
    AlunoTermoAdesaoLista,
    AlunoDados,
  },
  setup() {
    const route = useRoute()
    const swal = inject('$swal')
    const store = useStore()

    const state = reactive({
      proccess: false,
      composicaoPrimeira: null,
      composicaoAnterior: null,
      composicaoAtual: null,
      circunferenciaPrimeira: null,
      circunferenciaAnterior: null,
      circunferenciaAtual: null,
      avaliacaoId: 0,
      alunoId: 0,
      alunoNome: '',
      anamnese: null,
      assessment_date: moment().format('DD/MM/yyyy'),
      assessment_location: '',
      quantidadeAulasMes: null,
      planos: [],
      planoTreinoIdSelecionado: null,
    })

    // Ordena planos: prioriza os que cobrem hoje, depois por final_date DESC
    const planosOrdenados = computed(() => {
      const hoje = moment().format('YYYY-MM-DD')
      return [...state.planos].sort((a, b) => {
        const aCobre =
          moment(a.initial_date).format('YYYY-MM-DD') <= hoje &&
          moment(a.final_date).format('YYYY-MM-DD') >= hoje
        const bCobre =
          moment(b.initial_date).format('YYYY-MM-DD') <= hoje &&
          moment(b.final_date).format('YYYY-MM-DD') >= hoje

        // Planos que cobrem hoje vem primeiro
        if (aCobre && !bCobre) return -1
        if (!aCobre && bCobre) return 1

        // Depois ordena por final_date desc (o que termina mais tarde primeiro)
        return moment(b.final_date).valueOf() - moment(a.final_date).valueOf()
      })
    })

    // Cria uma variavel computed pra facilitar acesso ao array ordenado no template
    Object.defineProperty(state, 'planosOrdenados', {
      get() {
        return planosOrdenados.value
      },
    })

    onMounted(async () => {
      const id = route.params.id ? parseInt(route.params.id) : 0
      state.alunoId = id
      state.assessment_date = moment().format('DD/MM/yyyy')

      if (id > 0) {
        await carregarAluno(id)
        await carregarPlanos(id)
      }
    })

    async function carregarAluno(id) {
      try {
        const resp = await alunoRepository.AlunoGetById(id)
        if (resp.data?.success) {
          const aluno = resp.data.data
          state.alunoNome = `${aluno.name || ''}${aluno.surname ? ' ' + aluno.surname : ''}`.trim()
        }
      } catch (e) {
        console.error('Falha ao carregar aluno:', e)
      }
    }

    async function carregarPlanos(alunoId) {
      try {
        // Seta o student-manager pra o backend filtrar planos so desse aluno
        store.commit('SET_STUDENT', alunoId)
        const resp = await planosTreinoRepository.PlanosTreinoGet()
        state.planos = resp.data?.data || []
        if (state.planos.length > 0) {
          // Auto-seleciona o primeiro da ordenacao (cobre hoje OU termina mais tarde)
          state.planoTreinoIdSelecionado = planosOrdenados.value[0].id
          store.commit('SET_TRAINING_PLAN', state.planoTreinoIdSelecionado)
        }
      } catch (e) {
        console.error('Falha ao carregar planos:', e)
      }
    }

    function onTrocarPlano() {
      if (state.planoTreinoIdSelecionado) {
        store.commit('SET_TRAINING_PLAN', state.planoTreinoIdSelecionado)
      }
    }

    function formatDate(v) {
      if (!v) return '-'
      return moment(v).format('DD/MM/YYYY')
    }

    return {
      state,
      onTrocarPlano,
      formatDate,
    }
  },
}
</script>

<style scoped>
.header-aluno-plano {
  background: linear-gradient(90deg, #2d3a67 0%, #3d4f8a 100%);
  border-radius: 10px;
  padding: 14px 18px;
  color: #fff;
}
.header-label {
  color: #fff;
  font-weight: 600;
  font-size: 0.9rem;
  white-space: nowrap;
  margin-bottom: 0;
}
.header-input {
  background: #fff !important;
  color: #333 !important;
  border: none !important;
  border-radius: 6px !important;
}
.header-input:disabled {
  background: rgba(255, 255, 255, 0.7) !important;
  cursor: not-allowed;
}
</style>
